import { render, staticRenderFns } from "./mokuai10.vue?vue&type=template&id=048c5aee&"
import script from "./mokuai10.vue?vue&type=script&lang=js&"
export * from "./mokuai10.vue?vue&type=script&lang=js&"
import style0 from "./mokuai10.vue?vue&type=style&index=0&id=048c5aee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports